import { useEffect, useState } from 'react';
import { detectThemeSync, watchThemeChanges } from '../utils/themeUtils';

/**
 * Theme from Django/localStorage, kept in sync when the user toggles dark/light elsewhere.
 */
export function useSyncedTheme() {
  const [theme, setTheme] = useState(() => detectThemeSync());

  useEffect(() => watchThemeChanges(setTheme), []);

  return theme;
}
